export enum ToastMessagesPosition {
  BOTTOM_LEFT = 'bottom-left'
}

export enum ToastMessagesRenderTarget {
  DEFAULT,
  BODY
}
